import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Ultimate Sugargoo Spreadsheet Guide 2026',
    desc: 'Learn everything about Sugargoo Spreadsheet — from getting started to advanced product discovery. Find thousands of organized finds with our complete database guide.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20a%20colorful%20organized%20spreadsheet%20database%20on%20a%20warm%20wooden%20desk%2C%20coffee%20cup%20beside%20it%2C%20soft%20natural%20light%20from%20window%2C%20cream%20neutral%20background%2C%20editorial%20productivity%20photography%20with%20minimal%20aesthetic&width=800&height=450&seq=preview-spreadsheet-2026&orientation=landscape',
    path: '/sugargoo-spreadsheet-guide',
    tag: 'Guide',
    tagColor: 'bg-primary-100 text-primary-700',
    readTime: '8 min read',
  },
  {
    title: 'Sugargoo Shipping Cost: Complete Price Guide',
    desc: 'Understand Sugargoo shipping costs, methods, and factors that affect pricing. Compare express, air, and economy shipping options to save money on every order.',
    image: 'https://readdy.ai/api/search-image?query=International%20shipping%20packages%20stacked%20on%20a%20minimal%20surface%20with%20airplane%20and%20truck%20logistics%20icons%20floating%20above%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20editorial%20delivery%20concept%20photography&width=800&height=450&seq=preview-shipping-2026&orientation=landscape',
    path: '/sugargoo-shipping-cost-guide',
    tag: 'Shipping',
    tagColor: 'bg-secondary-100 text-secondary-700',
    readTime: '7 min read',
  },
  {
    title: 'Sugargoo Review 2026: Is Sugargoo Legit?',
    desc: 'An in-depth review of the Sugargoo platform covering user experience, shipping options, warehouse service, and everything you need to know before shopping.',
    image: 'https://readdy.ai/api/search-image?query=Laptop%20screen%20showing%20star%20ratings%20and%20review%20interface%20on%20a%20clean%20desk%2C%20magnifying%20glass%20leaning%20against%20it%2C%20warm%20natural%20lighting%2C%20cream%20neutral%20background%2C%20editorial%20review%20concept%20photography%20with%20soft%20shadows&width=800&height=450&seq=preview-review-2026&orientation=landscape',
    path: '/sugargoo-review-2026',
    tag: 'Review',
    tagColor: 'bg-accent-100 text-accent-700',
    readTime: '6 min read',
  },
  {
    title: 'Sugargoo Coupon & Discount Code Guide',
    desc: 'Find the latest Sugargoo coupons, discount codes, and money-saving strategies. Learn how to maximize savings on shipping and purchases with our guide.',
    image: 'https://readdy.ai/api/search-image?query=Discount%20tags%20and%20percentage%20off%20badges%20scattered%20around%20a%20minimal%20shopping%20bag%20on%20warm%20marble%20surface%2C%20soft%20pastel%20lighting%2C%20cream%20background%2C%20editorial%20savings%20concept%20photography%20with%20clean%20composition&width=800&height=450&seq=preview-coupon-2026&orientation=landscape',
    path: '/sugargoo-coupon-discount-code',
    tag: 'Savings',
    tagColor: 'bg-primary-100 text-primary-700',
    readTime: '5 min read',
  },
  {
    title: 'Sugargoo Warehouse Guide: Storage & QC',
    desc: 'Complete guide to the Sugargoo warehouse system including storage time, QC photos, inspection process, and how to prepare your parcel for shipping.',
    image: 'https://readdy.ai/api/search-image?query=Organized%20warehouse%20shelves%20with%20neatly%20labeled%20cardboard%20boxes%2C%20warm%20industrial%20lighting%20on%20concrete%20floor%2C%20minimal%20aesthetic%20with%20cream%20tones%2C%20editorial%20logistics%20photography%20with%20soft%20natural%20light&width=800&height=450&seq=preview-warehouse-2026&orientation=landscape',
    path: '/sugargoo-warehouse-guide',
    tag: 'Warehouse',
    tagColor: 'bg-secondary-100 text-secondary-700',
    readTime: '6 min read',
  },
  {
    title: 'Best Sugargoo Shoes Finds: Top Sneaker Picks',
    desc: 'Discover the best Sugargoo shoes, sneakers, and footwear finds. Our curated guide covers popular styles, sizing tips, and community-recommended picks.',
    image: 'https://readdy.ai/api/search-image?query=Premium%20athletic%20sneakers%20arranged%20in%20a%20stylish%20row%20on%20a%20warm%20wooden%20surface%2C%20clean%20white%20and%20neutral%20tones%2C%20soft%20studio%20lighting%2C%20editorial%20fashion%20product%20photography%20with%20minimal%20aesthetic&width=800&height=450&seq=preview-shoes-2026&orientation=landscape',
    path: '/best-sugargoo-shoes',
    tag: 'Shoes',
    tagColor: 'bg-accent-100 text-accent-700',
    readTime: '7 min read',
  },
  {
    title: 'Sugargoo Hoodies & Sweaters: Streetwear Essentials',
    desc: 'Everything you need to know about buying hoodies, sweaters, and streetwear on Sugargoo. From fabric types and sizing to the best community-verified finds.',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20hoodies%20and%20knitted%20sweaters%20folded%20neatly%20on%20a%20warm%20wooden%20table%2C%20neutral%20earth%20tone%20streetwear%20essentials%2C%20soft%20natural%20lighting%20from%20window%2C%20editorial%20fashion%20photography%20with%20clean%20minimal%20composition&width=800&height=450&seq=preview-hoodies-2026&orientation=landscape',
    path: '/sugargoo-hoodies-sweaters-guide',
    tag: 'Apparel',
    tagColor: 'bg-primary-100 text-primary-700',
    readTime: '6 min read',
  },
  {
    title: 'Sugargoo Accessories: Watches, Jewelry & More',
    desc: 'Comprehensive guide to buying accessories on Sugargoo including watches, jewelry, hats, sunglasses, belts, and more with quality assessment tips.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mens%20watch%20and%20sunglasses%20arranged%20with%20leather%20wallet%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20luxury%20accessory%20photography%20with%20minimal%20neutral%20tones%20and%20clean%20composition&width=800&height=450&seq=preview-accessories-2026&orientation=landscape',
    path: '/sugargoo-accessories-guide',
    tag: 'Accessories',
    tagColor: 'bg-secondary-100 text-secondary-700',
    readTime: '5 min read',
  },
  {
    title: 'Sugargoo Bags & Backpacks: Best Finds & Reviews',
    desc: 'Complete guide to buying bags, backpacks, luggage, and carry accessories on Sugargoo. Learn about materials, sizing, quality tiers, and top picks.',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20backpack%20and%20canvas%20tote%20bag%20arranged%20on%20warm%20wooden%20surface%2C%20minimalist%20travel%20accessory%20collection%20with%20cream%20tones%2C%20soft%20natural%20lighting%2C%20editorial%20travel%20photography%20with%20clean%20composition&width=800&height=450&seq=preview-bags-2026&orientation=landscape',
    path: '/sugargoo-bags-backpacks-guide',
    tag: 'Bags',
    tagColor: 'bg-accent-100 text-accent-700',
    readTime: '6 min read',
  },
  {
    title: 'Sugargoo Beginner Tutorial: First-Time User Guide',
    desc: 'Step-by-step tutorial for first-time Sugargoo users covering account setup, first order, warehouse process, shipping, and essential tips.',
    image: 'https://readdy.ai/api/search-image?query=Person%20opening%20a%20cardboard%20delivery%20box%20on%20a%20warm%20wooden%20desk%20with%20neatly%20wrapped%20items%20inside%2C%20soft%20natural%20lighting%20from%20window%2C%20cream%20neutral%20background%2C%20editorial%20lifestyle%20unboxing%20photography%20with%20warm%20earth%20tones&width=800&height=450&seq=preview-beginner-2026&orientation=landscape',
    path: '/sugargoo-beginner-tutorial',
    tag: 'Beginner',
    tagColor: 'bg-primary-100 text-primary-700',
    readTime: '8 min read',
  },
];

export default function ArticlePreview() {
  return (
    <section id="article-preview" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-label font-medium mb-4">
            Learning Center
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Guides &amp; Resources
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            In-depth articles and tutorials to help you master Sugargoo shopping. Browse all 10 guides below.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-300/50 transition-all cursor-pointer"
            >
              <div className="aspect-[16/9] w-full overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className={`px-2.5 py-0.5 rounded-full text-xs font-label font-medium ${article.tagColor}`}>
                    {article.tag}
                  </span>
                  <span className="text-xs text-foreground-500 font-label">{article.readTime}</span>
                </div>
                <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {article.desc}
                </p>
                <div className="flex items-center gap-1.5 mt-4 text-sm text-primary-600 font-label font-medium">
                  <span>Read Article</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}